module.exports = __webpack_public_path__ + "static/og-3-4f50bcbd6972e70671e3f11ff08c949a.jpg";